import { FC } from "react"
import styled from "@emotion/styled"

export const ListUnordered = styled.ul`
  all: unset;
  display: block;
`
